/*!
 * @monogrid/vue-boost v1.2.0 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { useWindowSize as G, breakpointsTailwind as C } from "@vueuse/core";
import { computed as c, unref as j } from "vue";
import { getEnv as k } from "../../index2.mjs";
import { useModernizr as B } from "../useModernizr/index.mjs";
var J = /* @__PURE__ */ ((t) => (t.WEBP = "webp", t.PNG = "png", t.JPG = "jpg", t))(J || {}), y = /* @__PURE__ */ ((t) => (t.CROP_FOCALPOINT = "focalpoint", t.CROP_ENTROPY = "entropy", t.CROP_TOP_LEFT = "top,left", t.CROP_TOP_RIGHT = "top,right", t.CROP_BOTTOM_LEFT = "botton,left", t.CROP_BOTTOM_RIGHT = "bottom,right", t))(y || {}), A = /* @__PURE__ */ ((t) => (t.FIT_FILL = "fill", t.FIT_SCALE = "scale", t.FIT_CROP = "crop", t.FIT_CLIP = "clip", t.FIT_MIN = "min", t.FIT_MAX = "max", t))(A || {});
const M = {}, _ = (t) => {
  if (!t)
    throw new Error("A MediaFile must be supplied");
  if (!t.metaData)
    throw new Error('"metaData" field must be included in the query for the mediaFile');
  return M[t.id] || (M[t.id] = JSON.parse(t.metaData)), M[t.id];
}, R = (t) => _(t)["image-lazy-src"], T = (t) => {
  const o = _(t);
  return parseInt(o["image-width"] || "0");
}, b = (t) => {
  const o = _(t);
  return parseInt(o["image-height"] || "0");
}, $ = (t) => T(t) / b(t), D = (t, { format: o, width: r, height: h, maxWidth: s, maxHeight: O, minWidth: N, quality: g, aspectRatio: E, fit: f, fillColor: S = "black", crop: P, focalPoint: l = { x: 0.5, y: 0.5 }, blur: v } = {}, w) => {
  if (!t)
    throw new Error("A MediaFile must be supplied");
  const u = k();
  let n = "" + u.OPTIMIZED_IMAGE_API_ENDPOINT + "/" + t.id;
  if (u.IS_OFFLINE && (n = u.API_ENDPOINT + u.SERVICE_STAGE + u.OPTIMIZED_IMAGE_API_ENDPOINT + "/" + t.id), g ? n += `?q=${Math.round(Math.max(1, Math.min(100, g)))}` : n += "?auto=compress", (r && h && !f || E && !f) && (f = "crop"), !r && s === "breakpoint" && w) {
    const a = Object.values(C).concat([0, 4096]);
    a.sort((e, I) => e > I ? 1 : -1);
    const p = a.find((e) => (N || 0) < e && w.value < e);
    p != null && (s = p * window.devicePixelRatio);
  }
  if (E && (n += `&ar=${E}`, s && typeof s == "number" && !r && (r = s), !r && !s && (r = T(t))), r && (n += `&w=${Math.round(Math.max(1, r))}`), h && (n += `&h=${Math.round(Math.max(1, h))}`), !r && s && typeof s == "number" && T(t) > s && (n += `&w=${Math.round(Math.max(1, s))}`), !h && O && b(t) > O && (n += `&h=${Math.round(Math.max(1, O))}`), v && (n += `&blur=${Math.max(0, Math.min(2e3, Math.round(v)))}`), f && Object.values(A).indexOf(f) !== -1 && (n += `&fit=${f}`, f === "fill" && (n += `&fill-color=${S}`)), P && Object.values(y).indexOf(P) !== -1 && (n += `&crop=${P}`, P === "focalpoint" && (n += `&fp-x=${Math.max(0, Math.min(1, l.x))}`, n += `&fp-y=${Math.max(0, Math.min(1, l.y))}`)), o)
    n += `&fm=${o}`;
  else {
    const a = B(), p = !!a.webp.value, e = t.mimeType === "image/gif" || t.id.indexOf(".gif") !== -1, I = t.mimeType === "image/svg+xml" || t.id.indexOf(".svg") !== -1, x = t.mimeType === "image/webp" || t.id.indexOf(".webp") !== -1, i = t.mimeType === "image/png" || t.id.indexOf(".png") !== -1, L = a["webp-alpha"];
    p && !e && !I && !x && (!i || i && L) && (n += "&fm=webp");
  }
  return n;
}, V = {
  getMetaData: _,
  getLazySrc: R,
  getWidth: T,
  getHeight: b,
  getAspectRatio: $,
  getOptimizedImageURL: D
}, X = (t, o) => {
  const { width: r } = G();
  return {
    url: c(() => D(t, j(o), r)),
    metaData: c(() => _(t)),
    aspectRatio: c(() => $(t)),
    width: c(() => T(t)),
    height: c(() => b(t)),
    lazySrc: c(() => R(t))
  };
};
export {
  y as OptimizedImageCropMode,
  A as OptimizedImageFitMode,
  J as OptimizedImageFormat,
  V as OptimizedImageUtils,
  X as default,
  X as useOptimizedImage
};
